import React from 'react'

export default function BorderRadiusBottomLeft({ color = '#7246B1', style = {} }) {
    return (
        <svg
            className='icons-icon'
            style={style}
            xmlns='http://www.w3.org/2000/svg'
            width='20'
            height='20'
            viewBox='0 0 20 20'
            fill='none'
        >
            <path d='M4 9V13C4 14.6569 5.34315 16 7 16H11' stroke={color} strokeWidth='1.25' strokeLinecap='round' />
        </svg>
    )
}
